import { Component, OnInit, Input, OnChanges, EventEmitter, Output, SimpleChange, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { Observable } from 'rxjs';
import { map, startWith, switchMap } from 'rxjs/operators';
// import {} from 'rxjs/add/operator/first';

@Component({
  selector: 'autocomplete',
  templateUrl: './autocomplete.component.html',
})
export class AutoComplete implements OnInit, OnChanges {
  public requiredClass: string = '';
  @Input() label: String;
  @Input() labelAppearance: string;
  @Input() placeholder : String;
  @Input() data : any[];
  @Input() displayValue : String;
  @Input() acValue : any;
  @Input() dataSourceFunction : any;
  @Input() disabled : boolean = false;
  @Input() required: boolean = false;
  @Output() acValueChange = new EventEmitter<any>();
  @Input() acReadonly : boolean = false; /* 2021-12-15 (aaangeles) */
  @ViewChild('autoCompleteInput', {read: MatAutocompleteTrigger }) autoCompleteInput: MatAutocompleteTrigger;

  public filteredOptions : Observable<any[]>
  public autocompleteFormControl = new FormControl();
  private opt : {};
  constructor() { 
    this.labelAppearance = this.labelAppearance || 'mat-form-field-no-label';
  }

  ngOnInit() {
      this.data = this.data || [];
  }

  ngOnChanges(changes: { [propName: string]: SimpleChange }){     
     if(changes.data){
         this.InicializaFiltrosAC();
     }
     if(changes.acValue && this.acValue != {}){
       if (this.data){
          if (this.acValue)
            this.autocompleteFormControl.setValue(this.data.find(d => d[this.displayValue.toString()] == this.acValue[this.displayValue.toString()]));
          else
            this.autocompleteFormControl.setValue(null);
       }  
     }

  }

  ngAfterViewInit(){
      
  }

  public clear(){
    this.autoCompleteInput.closePanel();
    this.autocompleteFormControl.setValue(null);
  }

  public ActualizaAutocomplete(ev:any){
    this.opt = ev.option.value;
    this.acValueChange.emit(this.opt);
  }

  public InicializaFiltrosAC() {
      this.filteredOptions = this.autocompleteFormControl.valueChanges.pipe(
          startWith(''),
          map(p => typeof p === 'string' || !p ? p : p[this.displayValue.toString()]),
          switchMap(p => p ? this.FilterAC(p) : [])
      )
  }

  async FilterAC(value : string){
    if (value == null) return;
    const filterValue = value.toLowerCase();
    if (this.dataSourceFunction) {
      this.data = await this.dataSourceFunction(value).toPromise() || [] ; /* 2021-12-27 (aaangeles) Elimina metodo first, devuelve array vacio en caso de tener respuesta indefinida */
      return this.data;
    } else {
      return this.data.filter(s => s[this.displayValue.toString()].toLowerCase().includes(filterValue))
    }
  }

  displayAC(p?: any): string | undefined {
    return p ? p[this.displayValue.toString()] : undefined;
  }

  public OnBlur(){
    setTimeout(() => {
      if(typeof this.autocompleteFormControl.value === "string"){
        if(this.autocompleteFormControl.value != ''){          
          if (this.data.length > 0){
            let val = this.autocompleteFormControl.value.toString().toLowerCase();
            this.acValue = this.dataSourceFunction ? this.data[0] : this.data.filter(s => s[this.displayValue.toString()].toLowerCase().includes(val))[0];
          } 
          else if(Object.keys(this.acValue).length > 0){
            this.autoCompleteInput.closePanel();
          } 
          else {
            this.acValue = {};
          }               
        }
        else {
          this.acValue = {};
        }
        this.autocompleteFormControl.setValue(!!this.acValue && Object.keys(this.acValue)?.length > 0 ? this.acValue : '');
        this.acValueChange.emit(this.acValue);
      }  
    }, 300);  
  }
}